module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-insurance page-inner"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "form_patient"
  }, [_c('Header'), _c('div', {
    staticClass: "service-inner inner-container"
  }, [_c('div', {
    staticClass: "patient-section insurance-section"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }), _c('hr'), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.content)
    }
  }), _c('div', {
    staticClass: "specials"
  }, [_c('div', {
    staticClass: "schedule_appoint_section"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_4_content.title)
    }
  }), _c('hr', {
    staticClass: "all_hr ins"
  }), _c('div', {
    staticClass: "email-container"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "company-info"
  }, [_c('ul', [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_4_content.address)
    }
  }), _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_4_content.phone)
    }
  }), _c('br'), _c('br'), _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_4_content.hours)
    }
  })])]), _c('div', {
    staticClass: "contact"
  }, [_vm._m(0), _c('div', {
    staticClass: "appoint-wrap contact-form"
  }, [_c('CustomForm')], 1)])])])])])])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Email Us")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-171ed9a6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/insurance/insurance.pug
// module id = 532
// module chunks = 1